export default {"src":"/_next/static/media/0x8A9C67fee641579dEbA04928c4BC45F66e26343A.a141e52c.svg","height":2000,"width":2000,"blurWidth":0,"blurHeight":0};